// Runtime feature flags. Read from CRA env at build time.
//
// The values are baked into the bundle when `npm run build` runs, so
// flipping a flag requires a rebuild — that's fine here, we only use
// these for coarse on/off of whole product surfaces.

function readFlag(value: string | undefined, defaultOn: boolean): boolean {
  if (value === undefined) return defaultOn;
  const v = value.trim().toLowerCase();
  if (v === 'on' || v === 'true' || v === '1' || v === 'yes') return true;
  if (v === 'off' || v === 'false' || v === '0' || v === 'no') return false;
  return defaultOn;
}

// Private Contracts AI surface (/contracts and the "Contracts AI (private)"
// entry points). Off by default — set REACT_APP_CONTRACTS_AI=on to turn it
// back on. The public AI concierge is a separate feature and is unaffected.
export const CONTRACTS_AI_ENABLED = readFlag(process.env.REACT_APP_CONTRACTS_AI, false);
